var React = require('react');

function FlagEn (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"300","height":"300","fill":"#00247d","key":0}),React.createElement("path",{"d":"M 0,0 L 300,300 M 300,0 L 0,300","stroke":"#fff","strokeWidth":"60","key":1}),React.createElement("path",{"d":"M 0,0 L 300,300 M 300,0 L 0,300","stroke":"#cf142b","strokeWidth":"40","key":2}),React.createElement("path",{"d":"M 150,150 v -30 L 30,0 H 0 z h 30 L 300,30 V 0 z v 30 L 270,300 H 300 z h -30 L 0,270 V 300 z","fill":"#fff","key":3}),React.createElement("path",{"d":"M 150,0 V 300 M 0,150 H 300","stroke":"#fff","strokeWidth":"100","key":4}),React.createElement("path",{"d":"M 150,0 V 300 M 0,150 H 300","stroke":"#cf142b","strokeWidth":"60","key":5})]);
}

FlagEn.defaultProps = {"viewBox":"0 0 300 300"};

module.exports = FlagEn;

FlagEn.default = FlagEn;
